import {
  PERFECT_FOR,
  FABRIC_CARE,
  COLLAR,
  WASH_CARE,
} from '@components/utils/textVariables'
import 'swiper/css'
import 'swiper/css/navigation'

import { IDeviceInfo } from '@components/ui/context'
import { IMAGE_ASSET_BASE_URL } from '@framework/utils/constants'

interface IProductSpecifications {
  attrGroup: any
  product: any
  deviceInfo: IDeviceInfo
}

export default function ProductSpecifications(props: IProductSpecifications) {
  const { attrGroup, product, deviceInfo } = props
  const { isOnlyMobile } = deviceInfo

  return (
    <>
      <div className={`flex flex-col ${isOnlyMobile ? 'px-4' : ''}`}>
        <div className="flex flex-col">
          <div className="grid grid-cols-2 gap-x-2 gap-y-0 sm:gap-x-4 sm:gap-y-1 sm:grid-cols-3">
            {attrGroup['product.collar']?.length > 0 && (
              <div className="pb-2 mb-1 border-b border-gray-200 sm:pb-3 sm:mb-3">
                <div className="flex flex-col mt-3 sm:mt-3">
                  <h4 className="mb-1 text-xs font-medium text-gray-400 uppercase sm:mb-2">
                    {COLLAR}
                  </h4>
                </div>
                <div className="flex flex-wrap">
                  {attrGroup['product.collar'].map(
                    (collarAttr: any, cdx: number) => (
                      <div className="flex justify-start comma" key={cdx}>
                        <span className="pr-1 mt-1 text-xs font-normal text-dark-brown sm:text-sm">
                          {collarAttr.fieldText}
                          <span className="s-icon">,</span>
                        </span>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}
            {attrGroup['product.features']?.length > 0 && (
              <div className="pb-2 mb-1 border-b border-gray-200 sm:pb-3 sm:mb-3">
                <div className="flex flex-col mt-3 sm:mt-3">
                  <h4 className="mb-1 text-xs font-medium text-gray-400 uppercase sm:mb-2">
                    Features
                  </h4>
                </div>
                <div className="flex flex-wrap">
                  {attrGroup['product.features']?.map(
                    (featureAttr: any, featureAttrdx: number) => (
                      <div
                        className="flex justify-start comma"
                        key={featureAttrdx}
                      >
                        <span className="pr-1 mt-1 text-xs font-normal text-dark-brown sm:text-sm">
                          {featureAttr?.fieldText}
                          <span className="s-icon">,</span>
                        </span>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}

            {attrGroup['product.length']?.length > 0 && (
              <div className="pb-2 mb-1 border-b border-gray-200 sm:pb-3 sm:mb-3">
                <div className="flex flex-col mt-3 sm:mt-3">
                  <h4 className="mb-1 text-xs font-medium text-gray-400 uppercase sm:mb-2">
                    Length
                  </h4>
                </div>
                <div className="flex flex-wrap">
                  {attrGroup['product.length']?.map(
                    (lengthAttr: any, ldx: number) => (
                      <div className="flex justify-start comma" key={ldx}>
                        <span className="pr-1 mt-1 text-xs font-normal text-dark-brown sm:text-sm">
                          {lengthAttr.fieldText}
                          <span className="s-icon">,</span>
                        </span>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}
            {attrGroup['product.fabric']?.length > 0 && (
              <div className="pb-2 mb-1 border-b border-gray-200 sm:pb-3 sm:mb-3">
                <div className="flex flex-col mt-3 sm:mt-3">
                  <h4 className="mb-1 text-xs font-medium text-gray-400 uppercase sm:mb-2">
                    Fabric Type
                  </h4>
                </div>
                <div className="flex flex-wrap">
                  {attrGroup['product.fabric']?.map(
                    (fabric: any, fdx: number) => (
                      <div className="flex justify-start comma" key={fdx}>
                        <span className="pr-1 mt-1 text-xs font-normal text-dark-brown sm:text-sm">
                          {fabric.fieldText}
                          <span className="s-icon">,</span>
                        </span>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}
            {attrGroup['product.fit']?.length > 0 && (
              <div className="pb-2 mb-1 border-b border-gray-200 sm:pb-3 sm:mb-3">
                <div className="flex flex-col mt-3 sm:mt-3">
                  <h4 className="mb-1 text-xs font-medium text-gray-400 uppercase sm:mb-2">
                    Fit
                  </h4>
                </div>
                <div className="flex flex-wrap">
                  {attrGroup['product.fit']?.map((fit: any, fdx: number) => (
                    <div className="flex justify-start comma" key={fdx}>
                      <span className="pr-1 mt-1 text-xs font-normal text-dark-brown sm:text-sm">
                        {fit.fieldText}
                        <span className="s-icon">,</span>
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {attrGroup['product.type']?.length > 0 && (
              <div className="pb-2 mb-1 border-b border-gray-200 sm:pb-3 sm:mb-3">
                <div className="flex flex-col mt-3 sm:mt-3">
                  <h4 className="mb-1 text-xs font-medium text-gray-400 uppercase sm:mb-2">
                    Type
                  </h4>
                </div>
                <div className="flex flex-wrap">
                  {attrGroup['product.type']?.map((fit: any, fdx: number) => (
                    <div className="flex justify-start comma" key={fdx}>
                      <span className="pr-1 mt-1 text-xs font-normal text-dark-brown sm:text-sm">
                        {fit.fieldText}
                        <span className="s-icon">,</span>
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {attrGroup['product.style']?.length > 0 && (
              <div className="pb-2 mb-1 border-b border-gray-200 sm:pb-3 sm:mb-3">
                <div className="flex flex-col mt-3 sm:mt-3">
                  <h4 className="mb-1 text-xs font-medium text-gray-400 uppercase sm:mb-2">
                    Style
                  </h4>
                </div>
                <div className="flex flex-wrap">
                  {attrGroup['product.style']?.map((fit: any, fdx: number) => (
                    <div className="flex justify-start comma" key={fdx}>
                      <span className="pr-1 mt-1 text-xs font-normal text-dark-brown sm:text-sm">
                        {fit.fieldText}
                        <span className="s-icon">,</span>
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        {attrGroup['product.perfectfor']?.length > 0 && (
          <>
            <div className="flex flex-col mt-3 sm:mt-3">
              <h4 className="mb-1 text-xs font-medium text-gray-400 uppercase sm:mb-2">
                {PERFECT_FOR}
              </h4>
            </div>
            <div className="grid grid-cols-2 gap-4 pr-4 mt-0 sm:grid-cols-4">
              {attrGroup['product.perfectfor']?.map(
                (perfectAttr: any, pdx: number) => {
                  if (perfectAttr?.fieldText !== null) {
                    return (
                      <div className="flex justify-start comma" key={pdx}>
                        <img
                          alt="Specification"
                          src={`${IMAGE_ASSET_BASE_URL}/icons/${perfectAttr.fieldText
                            .toLowerCase()
                            .replace(' ', '')}.svg`}
                          width={32}
                          height={32}
                        />
                        <span className="pl-2 mt-1 text-sm font-normal text-dark-brown sm:text-sm">
                          {perfectAttr?.fieldText}
                        </span>
                      </div>
                    )
                  }
                }
              )}
            </div>
          </>
        )}
        {attrGroup['product.fabriccare']?.length > 0 && (
          <>
            <div className="flex flex-col mt-6">
              <h4 className="mb-2 text-xs font-medium text-gray-400 uppercase">
                {FABRIC_CARE}
              </h4>
            </div>
            <div className="grid">
              <div className="flex w-full">
                {attrGroup['product.fabriccare']?.map(
                  (fabriccareAttr: any, idx: number) => (
                    <p
                      className="ml-0 text-xs sm:text-sm text-dark-brown care-p"
                      key={idx}
                    >
                      {fabriccareAttr?.fieldText}
                      <span className="s-icon">,</span>
                    </p>
                  )
                )}
              </div>
            </div>
          </>
        )}
        {attrGroup['product.washcare']?.length > 0 && (
          <>
            <div className="flex flex-col mt-6">
              <h4 className="mb-2 text-xs font-medium text-gray-400 uppercase">
                {WASH_CARE}
              </h4>
            </div>
            <div className="grid">
              <div className="flex w-full m-colum-div">
                {attrGroup['product.washcare']?.map(
                  (fabriccareAttr: any, idx: number) => (
                    <p
                      className="ml-0 text-xs sm:text-sm text-dark-brown care-p mob-full-p"
                      key={idx}
                    >
                      {fabriccareAttr?.fieldText}.
                      <span className="s-icon s-right-space"> </span>
                    </p>
                  )
                )}
              </div>
            </div>
          </>
        )}
        <>
          <div className="flex flex-col mt-6">
            <h4 className="mb-2 text-xs font-medium text-gray-400 uppercase">
              Product Details
            </h4>
          </div>
          <div className="grid">
            <div className="flex w-full m-colum-div">
              <div
                className={`flex flex-col ${
                  isOnlyMobile ? 'w-full' : 'w-6/12'
                }`}
              >
                <p className="ml-0 text-xs sm:text-sm text-dark-brown care-p mob-full-p">
                  Style Id: {attrGroup?.['product.stylecode']?.[0]?.fieldText}
                </p>
                <p className="ml-0 text-xs sm:text-sm text-dark-brown care-p mob-full-p mt-2">
                  Stock Code: {product?.stockCode}
                </p>
                <p className="ml-0 text-xs sm:text-sm text-dark-brown care-p mob-full-p mt-2">
                  Country of Origin:{' '}
                  {attrGroup?.['product.countryoforigin']?.[0]?.valueText ||
                    'India'}
                </p>
                <p className="ml-0 text-xs sm:text-sm text-dark-brown care-p mob-full-p mt-2">
                  Generic Name:{' '}
                  {attrGroup?.['product.genericname']?.[0]?.fieldText}
                </p>
                <p className="ml-0 text-xs sm:text-sm text-dark-brown care-p mob-full-p mt-2">
                  Quantity: {attrGroup?.['product.qty']?.[0]?.fieldText}
                </p>
              </div>
              <div
                className={`flex flex-col ${
                  isOnlyMobile ? 'w-full' : 'w-6/12'
                }`}
              >
                <p className="ml-0 text-xs sm:text-sm text-dark-brown care-p mob-full-p">
                  Manufactured and Marketed by:
                </p>
                <p className="ml-0 text-xs sm:text-sm text-dark-brown care-p mob-full-p mt-2">
                  DaMENSCH Apparel Pvt Ltd, JB House, 2nd Floor, No.110, 4th
                  Cross, 5th Block, Koramangala Industrial Layout, Bengaluru,
                  Karnataka 560095.
                </p>
              </div>
            </div>
          </div>
        </>
      </div>
    </>
  )
}
